import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

/**
 * PayU continueUrl handler. Redirects to the unified reservation page,
 * passing paymentId for optimistic display until IPN confirms.
 */
const PayuPaymentSuccessPage = () => {
  const { reservationId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!reservationId) {
      navigate('/book', { replace: true });
      return;
    }
    const paymentId = searchParams.get('paymentId');
    const target = paymentId
      ? `/reservation/${reservationId}?payuPaymentId=${encodeURIComponent(paymentId)}`
      : `/reservation/${reservationId}`;
    navigate(target, { replace: true });
  }, [reservationId, searchParams, navigate]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 8, gap: 2 }}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        Przetwarzanie płatności…
      </Typography>
    </Box>
  );
};

export default PayuPaymentSuccessPage;
